import { Link, Links, Meta, Outlet, Scripts, useRouteError } from 'react-router'
import { captureException } from '@sentry/react-router'
import './tailwind.css'
import type { PropsWithChildren } from 'react'
import { useEffect } from 'react'

function Layout({ children }: PropsWithChildren) {
  return (
    <html>
      <head>
        <meta charSet='utf-8' />
        <meta name='viewport' content='width=device-width,initial-scale=1' />
        <link rel='preconnect' href='https://cdn.shopify.com/' />
        <link
          rel='stylesheet'
          href='https://cdn.shopify.com/static/fonts/inter/v4/styles.css'
        />
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <Scripts />
      </body>
    </html>
  )
}

export default function App() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  )
}

export const ErrorBoundary = () => {
  const error = useRouteError()
  useEffect(() => {
    captureException(error)
  }, [error])

  const isLoadFailed =
    error instanceof Error && error.message?.includes('Load failed')

  return (
    <Layout>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: 24,
          fontFamily: 'system-ui, sans-serif',
          textAlign: 'center'
        }}
      >
        <p style={{ marginBottom: 16 }}>
          {isLoadFailed
            ? 'Connection failed while loading. This can happen when the app is starting up.'
            : 'Something went wrong.'}
        </p>
        <button
          type='button'
          onClick={() => window.location.reload()}
          style={{
            padding: '10px 20px',
            fontSize: 16,
            cursor: 'pointer',
            backgroundColor: '#008060',
            color: 'white',
            border: 'none',
            borderRadius: 8
          }}
        >
          Try again
        </button>
        {!isLoadFailed && (
          <Link to='/' style={{ marginTop: 16, color: '#008060' }}>
            Go to home
          </Link>
        )}
      </div>
    </Layout>
  )
}
